import { Dispatch } from "react";
import { ApiConfig } from "../../Config/CommonConfig";
import { GETAPI, POSTAPI, DELETEAPI, PUTAPI } from "../../API/Api";
import {
  GET_BADGE_LIST_FAIL,
  GET_BADGE_LIST_REQUEST,
  GET_BADGE_LIST_SUCCESS,
  CREATE_BADGE_REQUEST,
  CREATE_BADGE_SUCCESS,
  CREATE_BADGE_FAIL,
  UPDATE_BADGE_REQUEST,
  UPDATE_BADGE_SUCCESS,
  UPDATE_BADGE_FAIL,
  DELETE_BADGE_REQUEST,
  DELETE_BADGE_SUCCESS,
  DELETE_BADGE_FAIL,
  GET_CERTIFICATE_LIST_REQUEST,
  GET_CERTIFICATE_LIST_SUCCESS,
  GET_CERTIFICATE_LIST_FAIL,
  CREATE_CERTIFICATE_REQUEST,
  CREATE_CERTIFICATE_SUCCESS,
  CREATE_CERTIFICATE_FAIL,
  UPDATE_CERTIFICATE_REQUEST,
  UPDATE_CERTIFICATE_SUCCESS,
  UPDATE_CERTIFICATE_FAIL,
  DELETE_CERTIFICATE_REQUEST,
  DELETE_CERTIFICATE_SUCCESS,
  DELETE_CERTIFICATE_FAIL,
  UPLOAD_CERTIFICATE_TEMPLATE_REQUEST,
  UPLOAD_CERTIFICATE_TEMPLATE_SUCCESS,
  UPLOAD_CERTIFICATE_TEMPLATE_FAIL,
  CREATE_CERTIFICATE_CRITERIA_FAIL,
  CREATE_CERTIFICATE_CRITERIA_REQUEST,
  CREATE_CERTIFICATE_CRITERIA_SUCCESS,
  DELETE_CERTIFICATE_CRITERIA_FAIL,
  DELETE_CERTIFICATE_CRITERIA_REQUEST,
  DELETE_CERTIFICATE_CRITERIA_SUCCESS,
  GET_CERTIFICATE_CRITERIA_BY_ID_FAIL,
  GET_CERTIFICATE_CRITERIA_BY_ID_REQUEST,
  GET_CERTIFICATE_CRITERIA_BY_ID_SUCCESS,
  GET_CERTIFICATE_CRITERIA_LIST_FAIL,
  GET_CERTIFICATE_CRITERIA_LIST_REQUEST,
  GET_CERTIFICATE_CRITERIA_LIST_SUCCESS,
  UPDATE_CERTIFICATE_CRITERIA_FAIL,
  UPDATE_CERTIFICATE_CRITERIA_REQUEST,
  UPDATE_CERTIFICATE_CRITERIA_SUCCESS,
} from "../../Constants/RewardConstants";

export const BadgeListAction = (param: any) =>
  async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_BADGE_LIST_REQUEST });

      let data = await GETAPI(`${ApiConfig?.BadgeList}${param}`, false);

      if (data && data?.status === true) {
        dispatch({
          type: GET_BADGE_LIST_SUCCESS,
          data: data?.data,
        });
      } else {
        dispatch({
          type: GET_BADGE_LIST_FAIL,
          data: { rows: [], count: 0 },
        });
      }
    } catch (error) {
      dispatch({
        type: GET_BADGE_LIST_FAIL,
        data: { rows: [], count: 0 },
      });
    }
  };

export const CreateBadgeAction =
  (badgeData: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: CREATE_BADGE_REQUEST });

      let data = await POSTAPI(ApiConfig?.BadgeCreate, badgeData, true);

      if (data && data?.status === true) {
        dispatch({
          type: CREATE_BADGE_SUCCESS,
          data: data?.data,
        });

        return data;
      } else {
        dispatch({
          type: CREATE_BADGE_FAIL,
          data: null,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: CREATE_BADGE_FAIL,
        data: null,
      });
      return null;
    }
  };

export const UpdateBadgeAction =
  (badgeId: string, badgeData: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: UPDATE_BADGE_REQUEST });

      let data = await PUTAPI(
        `${ApiConfig?.BadgeUpdate}${badgeId}/`,
        badgeData,
        true
      );

      if (data && data?.status === true) {
        dispatch({
          type: UPDATE_BADGE_SUCCESS,
          data: data?.data,
        });

        return data;
      } else {
        dispatch({
          type: UPDATE_BADGE_FAIL,
          data: null,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: UPDATE_BADGE_FAIL,
        data: null,
      });
      return null;
    }
  };

export const DeleteBadgeAction =
  (badgeId: string) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: DELETE_BADGE_REQUEST });

      let data = await DELETEAPI(`${ApiConfig?.BadgeDelete}${badgeId}/`, true);

      if (data && data?.status === true) {
        dispatch({
          type: DELETE_BADGE_SUCCESS,
          data: data?.data,
        });

        return data;
      } else {
        dispatch({
          type: DELETE_BADGE_FAIL,
          data: null,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: DELETE_BADGE_FAIL,
        data: null,
      });
      return null;
    }
  };

export const CertificateListAction = (param?: string) => 
  async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_CERTIFICATE_LIST_REQUEST });
      let data = await GETAPI(`${ApiConfig?.CertificateList}${param}`, false);

      if (data && data?.status === true) {
        dispatch({
          type: GET_CERTIFICATE_LIST_SUCCESS,
          data: data?.data,
        });
      } else {
        dispatch({
          type: GET_CERTIFICATE_LIST_FAIL,
          data: { rows: [], count: 0 },
        });
      }
    } catch (error) {
      dispatch({
        type: GET_CERTIFICATE_LIST_FAIL,
        data: { rows: [], count: 0 },
      });
    }
  };

export const UploadCertificateTemplateAction =
  (imageData: { object_name: string; content_type: string }) =>
  async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: UPLOAD_CERTIFICATE_TEMPLATE_REQUEST });

      let data = await POSTAPI(
        ApiConfig?.BadgeUploadPresigned,
        imageData,
        false
      );

      if (data && data?.status === true) {
        dispatch({
          type: UPLOAD_CERTIFICATE_TEMPLATE_SUCCESS,
          data: data?.data,
        });
        return data;
      } else {
        dispatch({
          type: UPLOAD_CERTIFICATE_TEMPLATE_FAIL,
          data: null,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: UPLOAD_CERTIFICATE_TEMPLATE_FAIL,
        data: null,
      });
      return null;
    }
  };

export const CreateCertificateAction =
  (certificateData: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: CREATE_CERTIFICATE_REQUEST });

      let data = await POSTAPI(
        ApiConfig?.CertificateCreate,
        certificateData,
        true
      );

      if (data && data?.status === true) {
        dispatch({
          type: CREATE_CERTIFICATE_SUCCESS,
          data: data?.data,
        });

        return data;
      } else {
        dispatch({
          type: CREATE_CERTIFICATE_FAIL,
          data: null,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: CREATE_CERTIFICATE_FAIL,
        data: null,
      });
      return null;
    }
  };

export const UpdateCertificateAction =
  (certificateId: string, certificateData: any) =>
  async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: UPDATE_CERTIFICATE_REQUEST });

      let data = await PUTAPI(
        `${ApiConfig?.CertificateUpdate}${certificateId}/`,
        certificateData,
        true
      );

      if (data && data?.status === true) {
        dispatch({
          type: UPDATE_CERTIFICATE_SUCCESS,
          data: data?.data,
        });

        return data;
      } else {
        dispatch({
          type: UPDATE_CERTIFICATE_FAIL,
          data: null,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: UPDATE_CERTIFICATE_FAIL,
        data: null,
      });
      return null;
    }
  };

export const DeleteCertificateAction =
  (certificateId: string) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: DELETE_CERTIFICATE_REQUEST });

      let data = await DELETEAPI(
        `${ApiConfig?.CertificateDelete}${certificateId}/`,
        true
      );

      if (data && data?.status === true) {
        dispatch({
          type: DELETE_CERTIFICATE_SUCCESS,
          data: data?.data,
        });

        return data;
      } else {
        dispatch({
          type: DELETE_CERTIFICATE_FAIL,
          data: null,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: DELETE_CERTIFICATE_FAIL,
        data: null,
      });
      return null;
    }
  };

export const CertificateCriteriaListAction = (url: string) =>
  async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_CERTIFICATE_CRITERIA_LIST_REQUEST });
      
      let data = await GETAPI(url, false);

      if (data && data?.status === true) {
        dispatch({
          type: GET_CERTIFICATE_CRITERIA_LIST_SUCCESS,
          data: data?.data?.rows || [],
        });
      } else {
        dispatch({
          type: GET_CERTIFICATE_CRITERIA_LIST_FAIL,
          data: [],
        });
      }
    } catch (error) {
      dispatch({
        type: GET_CERTIFICATE_CRITERIA_LIST_FAIL,
        data: [],
      });
    }
  };

export const GetCertificateCriteriaByIdAction =
  (criteriaId: string) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: GET_CERTIFICATE_CRITERIA_BY_ID_REQUEST });

      let data = await GETAPI(
        `${ApiConfig?.CertificateCriteriaById}${criteriaId}`,
        false
      );

      if (data && data?.status === true) {
        dispatch({
          type: GET_CERTIFICATE_CRITERIA_BY_ID_SUCCESS,
          data: data?.data,
        });
        return data;
      } else {
        dispatch({
          type: GET_CERTIFICATE_CRITERIA_BY_ID_FAIL,
          data: null,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: GET_CERTIFICATE_CRITERIA_BY_ID_FAIL,
        data: null,
      });
      return null;
    }
  };

export const CreateCertificateCriteriaAction =
  (criteriaData: any) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: CREATE_CERTIFICATE_CRITERIA_REQUEST });

      let data = await POSTAPI(
        ApiConfig?.CertificateCriteriaCreate,
        criteriaData,
        true
      );

      if (data && data?.status === true) {
        dispatch({
          type: CREATE_CERTIFICATE_CRITERIA_SUCCESS,
          data: data?.data,
        });

        return data;
      } else {
        dispatch({
          type: CREATE_CERTIFICATE_CRITERIA_FAIL,
          data: null,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: CREATE_CERTIFICATE_CRITERIA_FAIL,
        data: null,
      });
      return null;
    }
  };

export const UpdateCertificateCriteriaAction =
  (criteriaId: string, criteriaData: any) =>
  async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: UPDATE_CERTIFICATE_CRITERIA_REQUEST });

      let data = await PUTAPI(
        `${ApiConfig?.CertificateCriteriaUpdate}${criteriaId}/`,
        criteriaData,
        true
      );

      if (data && data?.status === true) {
        dispatch({
          type: UPDATE_CERTIFICATE_CRITERIA_SUCCESS,
          data: data?.data,
        });

        return data;
      } else {
        dispatch({
          type: UPDATE_CERTIFICATE_CRITERIA_FAIL,
          data: null,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: UPDATE_CERTIFICATE_CRITERIA_FAIL,
        data: null,
      });
      return null;
    }
  };

export const DeleteCertificateCriteriaAction =
  (criteriaId: string) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: DELETE_CERTIFICATE_CRITERIA_REQUEST });

      let data = await DELETEAPI(
        `${ApiConfig?.CertificateCriteriaDelete}${criteriaId}/`,
        true
      );

      if (data && data?.status === true) {
        dispatch({
          type: DELETE_CERTIFICATE_CRITERIA_SUCCESS,
          data: data?.data,
        });

        return data;
      } else {
        dispatch({
          type: DELETE_CERTIFICATE_CRITERIA_FAIL,
          data: null,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: DELETE_CERTIFICATE_CRITERIA_FAIL,
        data: null,
      });
      return null;
    }
  };